import React, { Component } from "react";
import { Card, CardBody, FormGroup } from "reactstrap";
import Form, { Item, GroupItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react/button";
import { CheckBox } from "devextreme-react/check-box";
import { ScrollView } from "devextreme-react/scroll-view";
import { TextArea } from "devextreme-react/text-area";
import { config } from "../../utils/config";
import { callApi, showNotify, notifyType, notifyPosition } from "../../utils/utils";
import Scrollbar from "perfect-scrollbar";
import ContentEditable from "react-contenteditable";
import { RichUtils } from "draft-js";
import "./AlertaHTMLEditor.css";

class AlertaAlta extends Component {
    constructor(props) {
        super(props);

        this.state = {
            buscar: false,
            claTipoAlerta: "",
            claSubProducto: "",
            descripcion: "",
            esCritico: false,
            plantillaCuerpo: "",
            plantillaTitulo: "",
            plantillaDescripcion: "",
            Titulo: "",
            destinatarios: [],
            acciones: [],
            estatus: 0,
            usuarioOptions: [],
            accionesOptions: [],
            editable: true,
        };

        this.addDestinatarioButtonOptions = {
            onClick: () => {
                this.updateUsuarios();
            },
        };

        this.addAccionesButtonOptions = {
            onClick: () => {
                this.updateAcciones();
            },
        };

        this.btnBuscarDestinatarioHandleSubmit = this.btnBuscarDestinatarioHandleSubmit.bind(this);
        this.btnDeleteDestinatarioHandleSubmit = this.btnDeleteDestinatarioHandleSubmit.bind(this);
        this.btnDeleteAccionHandleSubmit = this.btnDeleteAccionHandleSubmit.bind(this);
        this.btnGuardarHandleSubmit = this.btnGuardarHandleSubmit.bind(this);
        this.btnCancelarHandle = this.btnCancelarHandle.bind(this);
        this.generateNewUserOptions = this.generateNewUserOptions.bind(this);
        this.generateNewAccionOptions = this.generateNewAccionOptions.bind(this);
        this.getUsuariosOptions = this.getUsuariosOptions.bind(this);
        this.getAccionesOptions = this.getAccionesOptions.bind(this);
        this.updateUsuarios = this.updateUsuarios.bind(this);
        this.refCard = React.createRef();
        this.refForm = React.createRef();

        this.ps = null;
    }

    componentDidMount() {
        this.setState({ usuarioOptions: this.getUsuariosOptions() });
        this.setState({ accionesOptions: this.getAccionesOptions() });

        if (this.refCard.current) {
            this.ps = new Scrollbar(this.refCard.current);
            this.ps.settings.suppressScrollX = true;
        }
    }

    componentWillUnmount() {
        if (this.ps) {
            this.ps.destroy();
            this.ps = null;
        }
    }

    componentDidUpdate() {
        this.ps.update(this.refCard);
    }

    /**
     * Regresa el objeto del formulario
     */
    get formAlerta() {
        return this.refForm.current ? this.refForm.current.instance : null;
    }

    /**
     * Funcion que se ejecuta al dar clic en el boton Buscar
     */
    btnBuscarDestinatarioHandleSubmit(index) {
        //let dataForm = this.formAlerta.option("formData");

        let claEmpleado = this.state.destinatarios[index].claveEmpleado;

        if (claEmpleado === "") {
            showNotify("Favor de capturar una Clave de Empleado", notifyPosition.centerTop, notifyType.error);
            return;
        }

        let urlWebService = config.urlKiwiAPI + "usuarios/usuariosObtener/" + claEmpleado;

        try {
            const functionCallback = (res) => {
                if(res.data.length > 0)
                {
                    let objUsuario = {
                        ClaveEmpleado: claEmpleado,
                        NombreEmpleado: res.data[0].nombre,
                    };
    
                    let destinatariosTmp = this.state.destinatarios;
                    destinatariosTmp[index].nombreEmpleado = objUsuario.NombreEmpleado;
                    this.setState({ destinatarios: destinatariosTmp });
                }
                else
                {
                    showNotify("Ha ocurrido un error: " + "Usuario no Existente, favor de agregar un usuario valido", notifyPosition.centerTop, notifyType.error);
                    console.log("Error: " + "Usuario no Existente, favor de agregar un usuario valido");
                }
            };

            callApi(urlWebService, "GET", null, functionCallback).catch((err) => {
                showNotify("Ha ocurrido un error: " + err.message, notifyPosition.centerTop, notifyType.error);
                console.log("Error: " + err.message);
            });
        } catch (err) {
            showNotify("Ha ocurrido un error: " + err.message, notifyPosition.centerTop, notifyType.error);
            console.log("Error: " + err.message);
        }
    }

    btnDeleteDestinatarioHandleSubmit(index) {
        let destinatariosTmp = [...this.state.destinatarios];
        destinatariosTmp.splice(index, 1);

        let usuariosTmp = [...this.state.usuarioOptions];
        usuariosTmp.splice(index, 1);
        this.setState({
            destinatarios: destinatariosTmp,
            usuarioOptions: usuariosTmp,
        });
    }

    btnDeleteAccionHandleSubmit(index) {
        if (this.props.estatus === 0) {
            let accionesTmp = [...this.state.acciones];
            accionesTmp.splice(index, 1);

            let accionesOTmp = [...this.state.accionesOptions];
            accionesOTmp.splice(index, 1);

            let indexTmp = 1;
            accionesTmp.forEach((element) => {
                element.idAccion = indexTmp;
                indexTmp++;
            });

            this.setState({
                acciones: accionesTmp,
                accionesOptions: accionesOTmp,
            });
        } else if (this.props.estatus === 1) {
            let accionesTmp = [...this.state.acciones];

            let accion = { ...accionesTmp[index], estatusAccion: 2 };

            accionesTmp[index] = accion;

            this.setState({
                acciones: accionesTmp,
            });
        }
    }

    eraseActions(index) {
        let accionesTmp = [...this.state.acciones];
        accionesTmp.splice(index, 1);

        let accionesOTmp = [...this.state.accionesOptions];
        accionesOTmp.splice(index, 1);

        let indexTmp = 1;
        accionesTmp.forEach((element) => {
            element.idAccion = indexTmp;
            indexTmp++;
        });

        this.setState({
            acciones: accionesTmp,
            accionesOptions: accionesOTmp,
        });
    }

    /**
     * Funcion que se ejecuta al dar clic en el boton Guardar
     */
    btnGuardarHandleSubmit() {
        let canSubmit = 1;
        if(this.state.plantillaTitulo === "" || this.state.plantillaTitulo.length === 0 || this.state.plantillaTitulo === null || this.state.plantillaTitulo === undefined)
        {
            canSubmit = 0;
            showNotify("Ha ocurrido un error: " + "Es necesario agregar un Título", notifyPosition.centerTop, notifyType.error);
            console.log("Error: " + "Es necesario agregar un Título");
            return;
        }

        if(this.state.plantillaDescripcion === "" || this.state.plantillaDescripcion.length === 0 || this.state.plantillaDescripcion === null || this.state.plantillaDescripcion === undefined)
        {
            canSubmit = 0;
            showNotify("Ha ocurrido un error: " + "Es necesario agregar una Descripción", notifyPosition.centerTop, notifyType.error);
            console.log("Error: " + "Es necesario agregar una Descripción");
            return;
        }
        let urlWebService = config.urlKiwiAPI + "Alert/AltaAlerta";

        let titulo = this.state.plantillaTitulo;
        let body = {
            ClaTipoAlerta: this.state.claTipoAlerta,
            ClaSubProducto: this.state.claSubProducto,
            Descripcion: this.state.descripcion,
            EsCritico: this.state.esCritico === true ? 1 : 0,
            PlantillaCuerpo: this.state.plantillaCuerpo,
            PlantillaTitulo: titulo,
            PlantillaDescripcion: this.state.plantillaDescripcion,
            Destinatarios: this.state.destinatarios,
            Acciones: this.state.acciones,
            Estatus: this.state.estatus,
            IdAlerta: this.state.idAlerta,
        };

        try {
            const functionCallback = (res) => {
                showNotify("Alerta guardada correctamente", notifyPosition.centerTop, notifyType.success);

                this.props.handler(false);
                window.location.reload();
            };

            if(canSubmit === 1)
            {
                callApi(urlWebService, "POST", body, functionCallback).catch((err) => {
                    showNotify("Ha ocurrido un error: " + err.message, notifyPosition.centerTop, notifyType.error);
                    console.log("Error: " + err.message);
                });
            }
        } catch (err) {
            showNotify("Ha ocurrido un error: " + err.message, notifyPosition.centerTop, notifyType.error);
            console.log("Error: " + err.message);
        }
    }

    /**
     * Función del botón para cancelar la operación y ocultar el modal
     */
    btnCancelarHandle() {
        //this.resetHandle();
        this.props.handler(false);
    }

    resetHandle() {
        while (this.state.destinatarios.length > 0) {
            this.btnDeleteDestinatarioHandleSubmit(this.state.destinatarios.length - 1);
        }
        while (this.state.acciones.length > 0) {
            this.eraseActions(this.state.acciones.length - 1);
        }

        this.setState({
            buscar: false,
            claTipoAlerta: this.props.claTipoAlerta,
            claSubProducto: this.props.claSubProducto,
            descripcioon: this.props.descripcion,
            esCritico: this.props.esCritico,
            plantillaCuerpo:
                this.props.plantillaCuerpo === ""
                    ? '<!DOCTYPE html><html><head><title></title><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><meta name="viewport" content="width=device-width, initial-scale=1"><meta http-equiv="X-UA-Compatible" content="IE=edge" /><style type="text/css"> body, table, td, a { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; } table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; } img { -ms-interpolation-mode: bicubic; } img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; } table { border-collapse: collapse !important; } body { height: 100% !important; margin: 0 !important; padding: 0 !important; width: 100% !important; } a[x-apple-data-detectors] {     color: inherit !important;     text-decoration: none !important;     font-size: inherit !important;     font-family: inherit !important;     font-weight: inherit !important;     line-height: inherit !important; } @media screen and (max-width: 480px) {     .mobile-hide {         display: none !important;     }     .mobile-center {         text-align: center !important;     } } div[style*="margin: 16px 0;"] { margin: 0 !important; } </style></head><body style="margin: 0 !important; padding: 0 !important; background-color: #eeeeee;" bgcolor="#eeeeee"><div style="display: none; font-size: 1px; color: #fefefe; line-height: 1px; font-family: Open Sans, Helvetica, Arial, sans-serif; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden;"> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus dolor aliquid omnis consequatur est deserunt, odio neque blanditiis aspernatur, mollitia ipsa distinctio, culpa fuga obcaecati! </div><table border="0" cellpadding="0" cellspacing="0" width="100%"><tr><td align="center" style="background-color: #eeeeee;" bgcolor="#eeeeee"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px;"><tr><td align="center" valign="top" style="font-size:0; padding: 35px;" bgcolor="#044767"><div style="display:inline-block; max-width:50%; min-width:100px; vertical-align:top; width:100%;"><table align="left" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:300px;"><tr><td align="left" valign="top" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 36px; font-weight: 800; line-height: 48px;" class="mobile-center"><h1 style="font-size: 36px; font-weight: 800; margin: 0; color: #ffffff;">Pedido @idFabricacion</h1></td></tr></table></div></td></tr><tr><td align="center" style="padding: 35px 35px 20px 35px; background-color: #ffffff;" bgcolor="#ffffff"><table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width:600px;"><tr><td align="center" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px; padding-top: 25px;"><h2 style="font-size: 30px; font-weight: 800; line-height: 36px; color: #333333; margin: 0;">                                 @cliente                             </h2></td></tr><tr><td align="left" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px; padding-top: 10px;"><p style="font-size: 16px; font-weight: 400; line-height: 24px; color: #777777;">                                 Fecha Cancelación: @fechaCancelacion                             </p></td></tr><tr><td align="left" style="padding-top: 20px;"><table cellspacing="0" cellpadding="0" border="0" width="100%"><tbody id="detalleEncabezado"><tr><td width="33%" align="left" bgcolor="#eeeeee" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 800; line-height: 24px; padding: 10px;">                                         ID                                     </td><td width="33%" align="left" bgcolor="#eeeeee" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 800; line-height: 24px; padding: 10px;">                                         Producto                                     </td><td width="33%" align="left" bgcolor="#eeeeee" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 800; line-height: 24px; padding: 10px;">                                         Cantidad Pedida                                     </td></tr><tr id="detalleRenglon"><td width="33%" align="left" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px; padding: 15px 10px 5px 10px;">                                         @idDetalle                                     </td><td width="33%" align="left" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px; padding: 15px 10px 5px 10px;">                                         @producto                                     </td><td width="33%" align="left" style="font-family: Open Sans, Helvetica, Arial, sans-serif; font-size: 16px; font-weight: 400; line-height: 24px; padding: 15px 10px 5px 10px;">                                         @cantidad                                     </td></tr></tbody></table></td></tr></table></td></tr></table></td></tr></table></body></html>'
                    : this.props.plantillaCuerpo,
            plantillaTitulo: this.props.plantillaTitulo,
            plantillaDescripcion: this.props.plantillaDescripcion,
            Titulo: this.props.titulo,
            destinatarios: this.props.destinatarios,
            acciones: this.props.acciones,
            estatus: this.props.estatus,
            idAlerta: this.props.idAlerta,
        });

        let someArray = this.state.acciones.filter((accion) => accion.estatusAccion === 2);

        this.setState({
            usuarioOptions: this.getUsuariosOptions(),
            accionesOptions: this.getAccionesOptions(),
        });
    }

    getUsuariosOptions() {
        var options = [];
        for (var i = 0; i < this.state.destinatarios.length; i++) {
            options.push(this.generateNewUserOptions(i));
        }
        return options;
    }

    getAccionesOptions() {
        var options = [];
        for (var i = 0; i < this.state.acciones.length; i++) {
            options.push(this.generateNewAccionOptions(i));
        }
        return options;
    }

    updateUsuarios() {
        this.setState({
            usuarioOptions: this.getUsuariosOptions(),
        });
    }

    updateAcciones = () => {
        this.setState({
            accionesOptions: this.getAccionesOptions(),
        });
    };

    handleChange = (evt) => {
        this.setState({ plantillaCuerpo: evt.target.value });
    };

    generateNewUserOptions(index) {
        return {
            buttons: [
                {
                    name: "trash",
                    location: "after",

                    options: {
                        stylingMode: "text",
                        icon: "trash",
                        onClick: () => {
                            this.updateUsuarios();
                        },
                    },
                },
            ],
        };
    }

    generateNewAccionOptions(index) {
        return {
            buttons: [
                {
                    name: "trash",
                    location: "after",

                    options: {
                        stylingMode: "text",
                        icon: "trash",
                        onClick: () => {
                            this.updateAcciones();
                        },
                    },
                },
            ],
        };
    }

    /**
     * Funcion que asigna el subproducto seleccionado a una variable
     * @param {Obj} select
     */
    onSubProductoChange = (select) => {
        this.setState({
            claSubProducto: select,
        });
        console.log(select);
    };

    onEsCriticoChanged = (args) => {
        // if (this.state.esCritico !== args.value) {
        //     this.setState({
        //         esCritico: args.value,
        //     });
        // }
    };

    /**
     * Funcion que asigna el tipo de alerta seleccionado a una variable
     * @param {Obj} select
     */
    onTipoAlertaChange = (select) => {
        this.setState({
            claTipoAlerta: select.value,
        });
        console.log(select);
    };

    onDescripcionChanged = (e) => {
        this.setState({
            PlantillaTitulo: e.value,
        });
    };

    render() {
        const filteredActions = this.state.acciones.filter((o) => o.estatusAccion !== 2);

        return (
            <ScrollView height="470px" width="100%" className="mt-1">
                <div ref={this.refCard}>
                    <Card>
                        <CardBody>
                            <Form
                                ref={this.refForm}
                                key={"formAlerta"}
                                id="formAlerta"
                                formData={this.state}
                                colCount={1}
                                showColonAfterLabel={true}
                                className="formAlerta"
                                id="FormAltaAlerta"
                            >
                                <GroupItem colSpan={3} colCount={3}>
                                    <Item
                                        dataField="claTipoAlerta"
                                        editorType="dxSelectBox"
                                        label={{ text: "Tipo Alerta" }}
                                        editorOptions={{
                                            dataSource: this.props.tipoalertas,
                                            searchEnabled: true,
                                            valueExpr: "claTipoAlerta",
                                            displayExpr: "descripcion",
                                            //onValueChanged: this.onTipoAlertaChange,
                                            placeholder: "Tipo de alerta",
                                        }}
                                    />
                                    <Item
                                        dataField="claSubProducto"
                                        editorType="dxSelectBox"
                                        label={{ text: "Sub Producto" }}
                                        editorOptions={{
                                            dataSource: this.props.subproductos,
                                            searchEnabled: true,
                                            valueExpr: "claSubProducto",
                                            displayExpr: "nomSubProducto",
                                            //onValueChanged: this.onSubProductoChange,
                                            placeholder: "Subproducto",
                                        }}
                                    />
                                    <Item
                                        dataField="esCritico"
                                        editorType="dxCheckBox"
                                        editorOptions={
                                            {
                                                //value: this.props.esCritico,
                                                //onValueChanged: this.onEsCriticoChanged,
                                            }
                                        }
                                    />
                                    <Item
                                        dataField="plantillaTitulo"
                                        editorType="dxTextArea"
                                        label={{ text: "Titulo" }}
                                        colSpan={1}
                                        editorOptions={
                                            {
                                                // value: this.props.plantillaTitulo,
                                                // onValueChanged: this.onDescripcionChanged,
                                            }
                                        }
                                    />
                                    <Item
                                        dataField="plantillaDescripcion"
                                        editorType="dxTextArea"
                                        colSpan={2}
                                        label={{ text: "Descripcion" }}
                                        editorOptions={
                                            {
                                                // value: this.props.plantillaTitulo,
                                                // onValueChanged: this.onDescripcionChanged,
                                            }
                                        }
                                    />
                                </GroupItem>
                                <GroupItem colSpan={2} colCount={2}>
                                    <Item>
                                        <Label text="Edición de Alerta" />
                                    </Item>
                                    <Item></Item>
                                    <Item>
                                        <textarea
                                            className="editable"
                                            value={this.state.plantillaCuerpo}
                                            onChange={this.handleChange}
                                            //onBlur={this.sanitize}
                                        />
                                    </Item>
                                    <Item>
                                        <ContentEditable
                                            className="editable"
                                            html={this.state.plantillaCuerpo} // innerHTML of the editable div
                                            disabled={!this.state.editable} // use true to disable edition
                                            onChange={this.handleChange} // handle innerHTML change
                                            //onBlur={this.sanitize}
                                        />
                                    </Item>
                                </GroupItem>
                                <GroupItem colSpan={1} colCount={1}>
                                    <Item>
                                        <Label text="Selección de destinatarios" />
                                    </Item>
                                    {this.state.usuarioOptions.map((usuario, index) => (
                                        <GroupItem colSpan={3} colCount={3}>
                                            <Item
                                                key={`destinatarios.claveusuario${index}`}
                                                id={`destinatarios.claveusuario${index}`}
                                                dataField={`destinatarios.${index}.claveEmpleado`}
                                                label={{ text: "Clave Empleado" }}
                                                title="Clave Empleado"
                                                editorOptions={
                                                    (usuario,
                                                    {
                                                        placeholder: "Clave de Usuario",
                                                    })
                                                }
                                            >
                                                <Label text={`Clave ${index + 1}`} />
                                            </Item>
                                            <Item
                                                key={`destinatarios.nombreusuario${index}`}
                                                id={`destinatarios.nombreusuario${index}`}
                                                dataField={`destinatarios.${index}.nombreEmpleado`}
                                                label={{ text: "Nombre Empleado" }}
                                                editorOptions={
                                                    (usuario, { text: this.state.destinatarios[index].nombreEmpleado })
                                                }
                                            ></Item>
                                            <GroupItem colSpan={3} colCount={3}>
                                                <Item>
                                                    <Button
                                                        id={`Buscador${index}`}
                                                        onClick={() => {
                                                            this.btnBuscarDestinatarioHandleSubmit(index);
                                                        }}
                                                        size="md"
                                                        className="btn btn-primary btn-round btn-icon btn-custom"
                                                        style={{ backgroundColor: "#fa7a50;" }}
                                                    >
                                                        <i className="fa fa-search" />
                                                    </Button>
                                                </Item>
                                                <Item>
                                                    <Button
                                                        id={`Borrador${index}`}
                                                        onClick={() => {
                                                            this.btnDeleteDestinatarioHandleSubmit(index);
                                                        }}
                                                        size="md"
                                                        className="btn btn-primary btn-round btn-icon btn-custom"
                                                        style={{ backgroundColor: "#fa7a50;" }}
                                                    >
                                                        <i className="fa fa-trash" />
                                                    </Button>
                                                </Item>
                                            </GroupItem>
                                        </GroupItem>
                                    ))}

                                    <Item>
                                        <Button
                                            id={`btnNuevoDestinatario`}
                                            onClick={() => {
                                                this.state.destinatarios.push({
                                                    key:
                                                        this.state.destinatarios.length === 0
                                                            ? 1
                                                            : this.state.destinatarios[
                                                                  this.state.destinatarios.length - 1
                                                              ].key + 1,
                                                    claveEmpleado: "",
                                                    clavePerfil: "",
                                                    nombreEmpleado: "",
                                                });
                                                this.updateUsuarios();
                                            }}
                                            size="md"
                                            className="btn btn-primary btn-round btn-icon btn-custom"
                                            style={{ backgroundColor: "#fa7a50;" }}
                                        >
                                            <i className="fa fa-plus" />
                                        </Button>
                                    </Item>
                                </GroupItem>
                                <GroupItem colSpan={1} colCound={1}>
                                    <Item>
                                        <Label text="Detalle de la acción" />
                                    </Item>
                                    {this.state.acciones
                                        .filter((accion) => accion.estatusAccion !== 2)
                                        .map((accion, index) => (
                                            <GroupItem colSpan={3} colCount={3}>
                                                <Item
                                                    colSpan={2}
                                                    key={`acciones.descripción${accion.idAccion - 1}`}
                                                    id={`acciones.descripción${accion.idAccion - 1}`}
                                                    dataField={`acciones.${accion.idAccion - 1}.descripción`}
                                                    label={{ text: "descripción" }}
                                                    title="Descripción"
                                                    editorOptions={{
                                                        placeholder: "Descripción de accion",
                                                    }}
                                                >
                                                    <Label text={`Clave ${accion.idAccion}`} />
                                                </Item>
                                                <Item colSpan={1}></Item>
                                                <Item
                                                    colSpan={1}
                                                    key={`acciones.claProducto${accion.idAccion - 1}`}
                                                    id={`acciones.claProducto${accion.idAccion - 1}`}
                                                    dataField={`acciones.${accion.idAccion - 1}.claProducto`}
                                                    label={{ text: "ClaProducto" }}
                                                    editorOptions={{
                                                        text: this.state.acciones[accion.idAccion - 1].claProducto,
                                                    }}
                                                ></Item>
                                                <Item
                                                    colSpan={1}
                                                    key={`acciones.idEntidad${accion.idAccion - 1}`}
                                                    id={`acciones.idEntidad${accion.idAccion - 1}`}
                                                    dataField={`acciones.${accion.idAccion - 1}.idEntidad`}
                                                    label={{ text: "IdEntidad" }}
                                                    editorOptions={{
                                                        text: this.state.acciones[accion.idAccion - 1].idEntidad,
                                                    }}
                                                ></Item>
                                                <GroupItem colSpan={1} colCount={1}>
                                                    <Item colSpan={1}>
                                                        <Button
                                                            id={`BorradorAccion${accion.idAccion - 1}`}
                                                            onClick={() => {
                                                                this.btnDeleteAccionHandleSubmit(accion.idAccion - 1);
                                                            }}
                                                            size="md"
                                                            className="btn btn-primary btn-round btn-icon btn-custom"
                                                            style={{ backgroundColor: "#fa7a50;" }}
                                                        >
                                                            <i className="fa fa-trash" />
                                                        </Button>
                                                    </Item>
                                                </GroupItem>
                                            </GroupItem>
                                        ))}
                                    <Item>
                                        <Button
                                            id={`btnNuevoAccion`}
                                            onClick={() => {
                                                this.state.acciones.push({
                                                    key:
                                                        this.state.acciones.length === 0
                                                            ? 1
                                                            : this.state.acciones[this.state.acciones.length - 1]
                                                                  .idAccion + 1,
                                                    idAccion:
                                                        this.state.acciones.length === 0
                                                            ? 1
                                                            : this.state.acciones[this.state.acciones.length - 1]
                                                                  .idAccion + 1,
                                                    descripción: "",
                                                    idEntidad: "",
                                                    claProducto: "",
                                                    estatusAccion: 0,
                                                });
                                                this.updateAcciones();
                                            }}
                                            size="md"
                                            className="btn btn-primary btn-round btn-icon btn-custom"
                                            style={{ backgroundColor: "#fa7a50;" }}
                                        >
                                            <i className="fa fa-plus" />
                                        </Button>
                                    </Item>
                                </GroupItem>
                            </Form>
                            <FormGroup className="text-right">
                                <Button
                                    id="btnUsersGuardar"
                                    text="Guardar"
                                    onClick={this.btnGuardarHandleSubmit}
                                    className="btn btn-primary btn-round"
                                />
                                <Button
                                    id="btnUsersCancelar"
                                    text="Cancelar"
                                    onClick={this.btnCancelarHandle}
                                    className="btn btn-primary btn-round"
                                />
                            </FormGroup>
                        </CardBody>
                    </Card>
                </div>
            </ScrollView>
        );
    }
}

export default AlertaAlta;
